<template>
  <div class="content">
    <div class="main">

      <!-- to end -->
      <div class="note">
        <div class="header" style="background-color: #67C23A">发起</div>
        <div class="content">{{ creator }}提交申请</div>
      </div>

      <div v-for="(item, index) in flowItemInfo" :key="item.id">
        <div class="next">
          <div class="line-area">
            <div class="line"></div>
            <div class="arrow"></div>
          </div>
          <div class="add" @click="onAddClick(index)">+</div>
        </div>

        <div class="note">
          <div class="header">{{ index | titleFilter }}</div>
          <div class="content" @click="onFlowClick(index)">
            <span class="width80">{{ item.type | typeFilter }}</span>
            <span class="right-click">{{ '>' }}</span>
          </div>
        </div>

      </div>

      <!-- to 抄送人 -->
      <div class="next" @click="onAddClick(-1)">
        <div class="line-area">
          <div class="line"></div>
          <div class="arrow"></div>
        </div>
        <div class="add">+</div>
      </div>

      <div class="note">
        <div class="header" style="background-color: #409EFF">抄送人(审批流程完成后默认抄送人)</div>
        <div class="content">
          <span v-if="drawerCopy2value.length === 0" class="width80">请选择抄送人</span>
          <span v-else class="width80">
            抄送人: <el-tag size="mini">{{ drawerCopy2value[0].name }}</el-tag>
            <el-tag size="mini" v-if="drawerCopy2value.length >= 2">{{ drawerCopy2value[1].name }}</el-tag>
            <span v-if="drawerCopy2value.length >= 3">...</span>
          </span>
          <span class="right-click" @click="onFlowClick(-1)">{{ '>' }}</span>
        </div>
      </div>

      <!-- to end -->
      <div class="next-end">
        <div class="line-area">
          <div class="line"></div>
          <div class="line-end"></div>
        </div>
      </div>

      <div class="end">
        <div class="end-content">流程结束</div>
        <div class="end-content">（审批流程结束, 发送消息推送并下发记录到设备）</div>
      </div>

    </div>

    <el-drawer :visible.sync="drawerShow" :with-header="false" direction="rtl" size="550px"
               :before-close="onDrawerClose">

      <div v-if="drawerShowType === `fix`" class="container">
        <header>审批人设置</header>
        <main>
          <el-form>
            <el-form-item>
              <el-radio v-model="selectApproveType" label="FREE">免审(默认通过)</el-radio>
              <el-radio v-model="selectApproveType" label="SELF">被访员工</el-radio>
              <el-radio v-model="selectApproveType" label="LEADER">员工所在部门主管</el-radio>
              <el-radio v-model="selectApproveType" label="SPECIFY">指定成员(只需一个审批通过)</el-radio>
            </el-form-item>


            <el-form-item v-if="selectApproveType === 'SPECIFY'">
              <el-select key="SPECIFY" v-model="drawerPeople" value-key="id" filterable remote reserve-keyword class="w-80"
                         placeholder="请输入成员的手机号/姓名" :remote-method="remoteMethod2"
                         :loading="drawerCopy2loading">
                <el-option v-for="item in drawerPeopleSearch" :key="item.id" :label="`${item.name} | ${item.tel} | ${item.departmentName}`"
                           :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </main>
        <footer>
          <div>
            <el-button type="primary" size="mini" @click="onSaveClick" :disabled="!hasCommitPermission">保存</el-button>
          </div>
          <div style="width: 12px;"></div>
          <template v-if="flowItemInfo.length >= 2">
            <div>
              <el-button type="danger" size="mini" @click="onDelClick" :disabled="!hasCommitPermission">删除</el-button>
            </div>
            <div style="width: 12px;"></div>
          </template>
          <div>
            <el-button size="mini" @click="onCancelClick">取消</el-button>
          </div>
        </footer>
      </div>
      <div v-else class="container">
        <header>审批人设置</header>
        <main>
          <el-select class="w-96" v-model="drawerCopy2value" value-key="id" multiple filterable remote reserve-keyword
                     placeholder="请输入成员的手机号/姓名" :remote-method="remoteMethod" :loading="drawerCopy2loading">
            <el-option v-for="item in drawerCopy2Options" :key="item.id" :label="`${item.name} | ${item.tel} | ${item.departmentName}`" :value="item"></el-option>
          </el-select>
        </main>
        <footer>
          <div>
            <el-button type="primary" size="mini" @click="onSaveClick" :disabled="!hasCommitPermission">保存</el-button>
          </div>
          <div style="width: 12px;"></div>
          <div>
            <el-button size="mini" @click="onCancelClick">取消</el-button>
          </div>
        </footer>
      </div>


    </el-drawer>
  </div>
</template>

<script>

import {getEmployeeByIds, guardSearchEmployee} from "@/api/organize-api";

export default {
  props: ['flowItemInfo', 'markCopy', 'visitType'],
  filters: {
    titleFilter(value) {
      return `${value + 1}级审批`
    },

    typeFilter(value) {
      switch (value) {
        case "FREE":
          return "免审";
        case "SELF":
          return "被访员工";
        case "LEADER":
          return "员工所在部门主管";
        case "SPECIFY":
          return "指定成员";
        default:
          return "未知"
      }
    }
  },
  mounted() {
    // this.updateCopyUser(this.markCopy)
    this.creator = this.visitType === 'subscribe' ? '访客' : '员工'
  },
  data() {
    return {
      creator: "",

      drawerCopy2Options: [], // 搜索出来的员工
      drawerCopy2value: [],   //
      drawerCopy2loading: false,
      drawerCopy2Users: [],   // 全部员工

      drawerPeople: {}, // 审批人设置选择员工
      drawerPeopleSearch: [],

      drawerShow: false,
      drawerShowType: "copyTo", // fix, copyTo

      selectApproveType: "",
      selectFlowIndex: 0,

      isRunning: false,
    }
  },
  methods: {

    async updateCopyUser(markCopy) {
      if (markCopy) {
        let copyList = markCopy.split("|")
        let res = await getEmployeeByIds(copyList)
        if (res.data.code === 200) {
          this.drawerCopy2Users = (res.data.data)
          this.drawerCopy2value = (res.data.data)
          this.drawerCopy2Options = (res.data.data)
        }
      } else {
        this.drawerCopy2Users = []
        this.drawerCopy2value = []
      }
    },

    onAddClick(value) {
      if (!this.hasCommitPermission) {
        return
      }
      console.log("onAddClick", value);
      if (this.flowItemInfo.length >= 5) {
        this.$message.error('至多只有五个审批人');
      } else {
        this.$emit('message', 'add', value);
      }

      // 判断是否可增加
      // 通知父元素新增
    },
    onFlowClick(value) {
      console.log("onFlowClick", value);
      this.selectFlowIndex = value
      if (value === -1) {
        this.drawerShowType = "copyTo"
      } else {
        this.drawerShowType = "fix"
        this.selectApproveType = this.flowItemInfo[value].type
        console.log("onFlowClick", this.flowItemInfo[value]);

        if (this.selectApproveType === 'SPECIFY' && this.flowItemInfo[value].employeeId) {
          let employeeIds = [this.flowItemInfo[value].employeeId]
          getEmployeeByIds(employeeIds).then(({data}) => {
            if (data.code === 200 && data.data.length > 0) {
              this.drawerPeople = data.data[0]
              this.drawerPeopleSearch = data.data
            }
          }).catch(err => {
            console.log(err)
          })
        }

      }
      this.drawerShow = true
    },
    onDrawerClose(done) {
      done()
    },
    onSaveClick() {
      if (this.selectFlowIndex == -1) {
        this.$emit('message', 'saveCopyTo', this.drawerCopy2value);
      } else {
        let data = this.flowItemInfo
        data[this.selectFlowIndex].type = this.selectApproveType
        if (this.selectApproveType === 'SPECIFY' && this.drawerPeople) {
          data[this.selectFlowIndex].employeeId = this.drawerPeople.id
        }

        this.$emit('message', 'saveFlow', data);
      }
      this.drawerShow = false

    },
    onCancelClick() {
      this.drawerShow = false
    },
    onDelClick() {
      this.$emit('message', 'del', this.selectFlowIndex);
      this.drawerShow = false
    },

    remoteMethod(query) {
      this.drawerCopy2loading = true;
      if (query !== '') {
        let param = {}
        if (isNaN(query)) {
          param = {name: query}
        } else {
          param = {tel: query}
        }
        guardSearchEmployee(param).then(({data}) => {
          if (data.code === 200) {
            this.drawerCopy2Options = data.data
          }
          this.drawerCopy2loading = false;
        }).catch(err => {
          console.log(err)
          this.drawerCopy2loading = false;
        })
      } else {
        this.drawerCopy2Options = []
        this.drawerCopy2loading = true;
      }
    },
    remoteMethod2(query) {
      this.drawerCopy2loading = true;
      if (query !== '') {
        let param = {}
        if (isNaN(query)) {
          param = {name: query}
        } else {
          param = {tel: query}
        }
        guardSearchEmployee(param).then(({data}) => {
          if (data.code === 200) {
            this.drawerPeopleSearch = data.data
          }
          this.drawerCopy2loading = false;
        }).catch(err => {
          console.log(err)
          this.drawerCopy2loading = false;
        })
      } else {
        this.drawerPeopleSearch = []
        this.drawerCopy2loading = true;
      }
    }
  },
  computed: {
    hasCommitPermission() {
      switch (this.$store.state.roleType) {
        case "ADMIN":
        case "MANAGE":
          return true
        case "VIEW":
        case "GUARD":
        case "STAFF":
          return false
        default:
          return this.$store.state.myPermissions.includes("VISITOR_FLOW_MODIFY")
      }
    }
  },

  watch: {
    markCopy: {
      handler: function (newValue, oldValue) {
        this.updateCopyUser(newValue)
      },
      immediate: true
    }
  }

}
</script>


<style lang="less" scoped>
.content {
  justify-content: center;
}

.main {
  width: 300px;
  margin: 0 auto;
}

.next-end {
  position: relative;

  width: 300px;
  height: 80px;
  text-align: center;

  .line-area {
    width: 100%;
    height: 100%;
  }

  .line {
    width: 2px;
    height: 70px;
    margin-left: auto;
    margin-right: auto;
    background-color: gray;
  }

  .line-end {
    position: relative;
    width: 15px;
    height: 15px;
    margin-left: auto;
    margin-right: auto;
    background-color: gray;
    border-radius: 50%;
    transform: translate(0, -50%);

  }
}

.next {
  position: relative;

  width: 300px;
  height: 100px;
  text-align: center;

  .line-area {
    width: 100%;
    height: 100%;
  }

  .line {
    width: 2px;
    height: 90px;
    margin-left: auto;
    margin-right: auto;
    background-color: gray;
  }

  .arrow {
    position: relative;
    width: 0;
    height: 0;
    margin-left: auto;
    margin-right: auto;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid gray;
  }


  .add {
    width: 30px;
    height: 30px;
    color: white;
    text-align: center;
    font-size: 25px;
    line-height: 25px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background-color: skyblue;
  }
}

.end {
  width: 300px;
  font-size: small;
  color: gray;

  .end-content {
    width: 100%;
    text-align: center;
    margin: 0 auto;
  }
}

.note {
  width: 300px;
  height: 90px;

  .header {
    height: 40px;
    background-color: #E6A23C;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;

    padding-left: 20px;
    line-height: 40px;
    color: white;
    font-size: 14px;
  }

  .content {
    height: 50px;
    background-color: white;
    border: 1px solid #c0c4cc;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    padding-left: 20px;
    line-height: 50px;
    font-size: 14px;

    .width80 {
      display: inline-block;
      width: 90%;
    }

    .right-click {
      display: inline-block;
      color: #c0c4cc;
      width: 20px;
      height: 20px;
      font-size: 20px;
    }
  }
}

.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  /* 设置容器高度占满整个视口 */


  header {
    height: 50px;
    line-height: 50px;
    padding-left: 12px;
    /* 固定头部高度 */
    border-bottom: 1px solid gray;
  }

  main {
    flex: 1;
    /* 中间内容自动拉伸 */
    border-bottom: 1px solid gray;

    padding: 12px;

  }

  footer {
    height: 50px;
    display: flex;
    justify-content: center;

    div {
      height: 50px;
      line-height: 50px;
    }

    /* 固定底部高度 */
  }

  .button-ensure {
    margin: 0 10px;
    /* 左右间距 */
  }

  .button-cancel {
    margin: 0 10px;
    /* 左右间距 */
  }
}

</style>
